import React, { useContext } from 'react';
import { Context } from '../../context/context';
import { APPCONFIG } from '../../app.config';

import Header from './Header';
import NavBar from './NavBar';
import { useEffect } from 'react';
import Home from './components/Home';
import Footer from './components/Footer/Footer';

export default function Menu() {
    const [context] = useContext(Context);

    const ruta = (APPCONFIG.SITE.WEBNH) == "google" ? "https://www.google.com/" : APPCONFIG.SITE.WEBNH + '/Principal.aspx';
    const idTipoUsuario = sessionStorage.getItem('idTipoUsuario');
    sessionStorage.setItem("panelActual", "");                    
    sessionStorage.setItem("appActual", "");                    

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Header />
            <div style={{ display: 'flex' }}>
                {context ? <NavBar /> : ""}
                <div style={{ boxSizing: 'content-box', width: '100%', overflow: 'hidden' }}>           
                    <Home idTipoUsuario={idTipoUsuario} />
                </div>
            </div>
            <Footer />
        </div>
    );
};